///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component, inject } from '@angular/core';
import { AbstractDialogManager } from '../../../dialog-manager/abstract-dialog-manager';
import { Observable } from 'rxjs';
import { UserService } from '../../service/user.service';
import { SaleDeleteDialogComponent } from './sale-delete-dialog.component';
import { SaleWithCompaniesCountProjection } from '../../../generated/shared-types.model';

@Component({
    selector: 'winde-delete-sale-dialog-wrapper-component',
    template: '',
    standalone: false
})
export class DeleteSaleDialogWrapperComponent extends AbstractDialogManager<SaleWithCompaniesCountProjection, SaleDeleteDialogComponent> {
    private readonly userService = inject(UserService);

    constructor() {
        super(SaleDeleteDialogComponent);
        this.openDialog();
    }

    preparingBaseConfig(): void {
        this.baseConfig.width = '800px';
        this.baseConfig.position = { top: '30px' };
        this.baseConfig.data.id = +this.activatedRoute.snapshot.paramMap.get('id') || null;
    }

    override findById(id: number): Observable<SaleWithCompaniesCountProjection> {
        return this.userService.findSaleById(id);
    }
}
